module.exports = __webpack_public_path__ + "media/images/web_suite/icon_learn_site-9ee4d84f07f57ccacf1aaa06e7d4fcd9.png";